import React from 'react';
import ReactDOM from 'react-dom';
import PopulationSpreadSim from './PopulationSpreadSim'
import { initializeSimulationState, simulator, statesList, linkRenderer, nodesRenderer } from './withDeathSimulator'

const WithSocialDistancingControls = ({ portalId, graph, deathRates }) => {
  const [isEWorkOn, setIsEWorkOn] = React.useState(true)
  const [isNEWorkOn, setIsNEWorkOn] = React.useState(true)
  const [isFriendsOn, setIsFriendsOn] = React.useState(true)
  const [isFamilyOn, setIsFamilyOn] = React.useState(true)
  const [isIFamilyOn, setIsIFamilyOn] = React.useState(true)

  const inPlayHash = {
    "IMMEDIATE-FAMILY": isIFamilyOn,
    FAMILY: isFamilyOn,
    "ESSENTIAL-WORK": isEWorkOn,
    "NON-ESSENTIAL-WORK": isNEWorkOn,
    FRIENDS: isFriendsOn
  }

  const linksInPlay = (type, day) => {
    return inPlayHash[type]
  }

  return ReactDOM.createPortal(
    <PopulationSpreadSim
      width={600}
      height={500}
      simulator={simulator}
      statesList={statesList}
      initializeSimulationState={initializeSimulationState}
      linkRenderer={linkRenderer}
      nodesRenderer={nodesRenderer}
      graph={graph}
      zoom={0.75}
      controls={{
        ...deathRates,
        linksInPlay
      }}
    >
      <span className="connection-types">Connection Types:</span>
      <div className="connection-controls">
        <label>
          <input
            name="isFriendsOn"
            type="checkbox"
            checked={isFriendsOn}
            onChange={() => { setIsFriendsOn(!isFriendsOn) }} 
          />
          Social Contact
        </label>
        <label>
          <input
            name="isNEWorkOn"
            type="checkbox"
            checked={isNEWorkOn}
            onChange={() => { setIsNEWorkOn(!isNEWorkOn) }} 
          />
          Non-essential Work
        </label>
        <label>
          <input
            name="isGoing"
            type="checkbox"
            checked={isEWorkOn}
            onChange={() => { setIsEWorkOn(!isEWorkOn) }} 
          />
          Essential Work
        </label>
        <label>
          <input
            name="isGoing"
            type="checkbox"
            checked={isFamilyOn}
            onChange={() => { setIsFamilyOn(!isFamilyOn) }} 
          />
          Family
        </label>
        <label>
          <input
            name="isGoing"
            type="checkbox"
            checked={isIFamilyOn}
            onChange={() => { setIsIFamilyOn(!isIFamilyOn) }} 
          />
          Immediate Family
        </label>
      </div>
    </PopulationSpreadSim>,
    document.getElementById(portalId)
  );
};

export default WithSocialDistancingControls;